import { ComparatorUtils } from './comparator-utils';
import { DropdownItem } from '../models/dropdown-item';

export class PioneerUtils {
  static getLastElement(elements: any[]) {
    return elements && elements.length > 0 ? elements[elements.length - 1] : null;
  }

  static safeTrim(value: string): string {
    return !value ? value : value.trim();
  }

  static trimToNull(value: string): string {
    const trimmedValue = this.safeTrim(value);
    return trimmedValue && trimmedValue.length > 0 ? trimmedValue : null;
  }

  static orderDropdownByValue(dropdownItems: DropdownItem[]) {
    dropdownItems.sort((anItem, anotherItem) => {
      return ComparatorUtils.compareString(anItem.value, anotherItem.value);
    });
  }

  static safeSubstring(value: string, start: number, end?: number): string {
    let result = undefined;
    if (value) {
      if (end) {
        result = value.substring(start, end);
      } else {
        result = value.substring(start);
      }
    }
    return result;
  }

  static addTrailingZeros(value: number): string {
    if (!value) {
      return '0.00';
    }
    let [, fraction = ''] = (value || '').toString().split('.');
    if (fraction.length < 2) {
      return value.toFixed(2);
    }
    return '' + value;
  }

  static formatDecimal(value: string, decimalPlaces = 2): string {
    const factor = Math.pow(10, decimalPlaces);
    const parsedValue = parseFloat(value);
    if (isNaN(parsedValue)) {
      return value;
    }
    const truncated = Math.floor(parsedValue * factor) / factor;
    return truncated.toFixed(decimalPlaces);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/pioneer-utils.ts